var AppLink = {
	countryCode:'TR',
	siteKey: '' ,
	setCountryCode: function(code){
		var code = code.toUpperCase();
		if(code=='INTBUT'){ //international site icin flag.country bu sekilde geliyor.
			code='TR';
		}
		this.countryCode = code;
	}
};

$(document).ready(function() {
	if(siteId == 1){
		$("#gsm_invite").mask("(999) 999-9999");
	}else{
		$("#gsm_invite").mask("999999999999999");
	}
	
	$("#gsm_code_invite").intlTelInput({
		preferredCountries: [AppLink.countryCode],
		americaMode: false
	});


	$("#gsm_code_invite").focusout(function(){
		var isTR = $("[name=gsm_code_invite]").val().includes("+90");
		if(isTR){
			$("[name=gsm_invite]").mask("(999) 999-9999");
		}else{
			$("[name=gsm_invite]").mask("999999999999999");
		}
	});

});

var recaptchaAppLink;
function onloadCallbackAppLink(){
    recaptchaAppLink = grecaptcha.render('recaptchaAppLink', {
        'sitekey' : AppLink.siteKey
    });
}

function postInfo(){
	
    var emailInput = $.trim($("#email_invite").val());
    var gsmInput = $.trim($("#gsm_invite").val());
    if(grecaptcha.getResponse(recaptchaAppLink).length > 0){
	       if(emailInput)
   				sendEmail();
   		   if(gsmInput)
   			  	sendSMS();
    } 
    else{
		alert(FmtMessage.getMessage('js.check.googlecaptcha.warn'));
		return;
    }
}


var showSuccessDiv = function(){
	$("#eventSuccess").show();
}

function sendSMS(){
	var value = $("#gsm_invite").val();
	var gsmNumbers = value.trim().replace(/\D/g,'');
	var gsmCode = $("#gsm_code_invite").val().trim().replace(/\D/g,'');
	
	if(gsmCode == 90 && gsmNumbers.length < 10){
		alert(FmtMessage.getMessage('js.general.gsm'));
		return;
	}
	openLoaderBox();
	
	$.ajax({
		async : false,
		dataType : "json",
		url : "/sendMobileLink/sms",
		data : {
			gsmCode : gsmCode,
			gsm:gsmNumbers,
			
		},
		success : function(data) {
			if (data) {
				$("#smsInfo").show();
			}
			closeLoaderBox();
		}
	}).done(function() {
    		showSuccessDiv();
    }).fail(function() {
    		alert(FmtMessage.getMessage('js.send.fail'));
    });
    	grecaptcha.reset(recaptchaAppLink);
}

function sendEmail() {
    var email = $("#email_invite").val();
    var isEmailValid = emailValidation('email_invite');

    if (!isEmailValid) {
        return false;
    }

    openLoaderBox();
    $.ajax({
        async: false,
        dataType: "json",
        url: "/sendMobileLink/email",
        data: {
            emailAddress: $("#email_invite").val()
        },
        success: function (data) {
            if (data) {
                $("#emailInfo").show();
            }
            closeLoaderBox();
        }
    }).done(function () {
        showSuccessDiv();
    }).fail(function () {
        alert(FmtMessage.getMessage('js.send.fail'));
    });

    grecaptcha.reset(recaptchaAppLink);
}